// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","9777":"recorder"}[chunkId] || chunkId) + "." + {"12":"c031424db17375e2","99":"0a18398b096cce82","2480":"e17521e146b1233a","6844":"8afdf502ce291508","9777":"58182b9e16deff41"}[chunkId] + ".js";
};